import { KitInlineForm } from "./KitInlineForm";

// Signup now feeds the Tattooed Abroad Kit subscriber form. The surrounding
// section styling, copy and spacing are preserved by each caller; only the
// form functionality is provided by Kit's inline embed.
export const EmailSignup = ({ source = "website" }) => (
  <div data-testid={`email-signup-${source}`} className="w-full">
    <KitInlineForm />
  </div>
);
